import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgChartsModule } from 'ng2-charts';
import { LoaderComponent } from './components/loader/loader.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { SnackbarComponent } from './components/snackbar/snackbar.component';
import { InViewportDirective } from './directives/in-viewport.directive';

import { UtilitiesService } from '../services/utilities.service';
import { MatIconModule } from '@angular/material/icon';
import { ActiveRouteDirective } from './directives/active-route.directive';
import { HasRoleDirective } from './directives/has-role.directive';
import { MiddleClickDirective } from './directives/middle-click.directive';

@NgModule({
	imports: [CommonModule, FormsModule, RouterModule, NgChartsModule, MatIconModule, HasRoleDirective, ActiveRouteDirective, MiddleClickDirective],
	declarations: [SidenavComponent, InViewportDirective, PaginatorComponent, SnackbarComponent, LoaderComponent, PageHeaderComponent],
	exports: [SidenavComponent, InViewportDirective, PaginatorComponent, SnackbarComponent, LoaderComponent, PageHeaderComponent],
	providers: [
		//AppService,
		HttpClient,
		UtilitiesService
	]
})
export class SharedModule {}
